import PusherClient from 'pusher-js';

class Pusher {
  constructor(appKey) {
    this.client = new PusherClient(appKey, {
      encrypted: true,
    });
  }

  subscribeToEventChannel(eventId, store) {
    try {
      const channelName = 'event-' + eventId;
      if (this.client !== null) {
        // Subscribe to channel
        this.channel = this.client.subscribe(channelName);
        // Set update function as handler for channel events
        try {
          this.channel.bind('update', function(json) {
            if (json.length === 0) return;
            for (let i = 0, l = json.length; i < l; i++) {
              const response = json[i];
              store.dispatch('RacingOddsComparisonTable/updateOdds', { eventId: eventId, response: response });
            }
          });
        } catch (error) {
          console.error('Error binding pusher function:', error);
        }
      }
    } catch (error) {
      console.error('Error subscribing to channel:', error);
    }
  }
}

export default Pusher;
